import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Image, Header, Icon, Button} from 'semantic-ui-react';

const icon = require('../../img/icons/error.svg');

class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
        console.log(error);
        console.log(errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        return <div>
                <Helmet>
                <title>Upps!!! Tenemos un problema - Bisttros</title>
                </Helmet>
                <br/>
                <Header as='h1' icon textAlign='center'>
                    <Icon><Image centered src={icon} style={{width:'60vw'}} alt='logo'/></Icon>
                </Header>
                <br />
                <p style={{textAlign:'center'}}>
                    <Button animated='fade' primary onClick={() => window.location.href = '/'}>
                        <Button.Content visible>Regresar a Bisttros</Button.Content>
                        <Button.Content hidden><Icon name='refresh' /></Button.Content>
                    </Button>
                </p>
            </div>
      }
  
      return this.props.children; 
    }
  }

  export default ErrorBoundary;
  


// WEBPACK FOOTER //
// ./src/components/extras/ErrorBoundary.js